import React from "react";
import Input from "./Input";

export default class GPS extends React.Component<any, any> {
  render() {
    const { field, linkToMap, ...props } = this.props;
    return (
      <>
        <Input field={field} {...props} />
        {linkToMap && field.value && (
          <div>
            <a
              href={`https://maps.google.com/?q=${field.value}`}
              target="_blank"
            >
              Open in Google Map
            </a>
          </div>
        )}
      </>
    );
  }
}
